import { EmptyState, PageHeader } from '@hemmafixa/ui';
import { SearchX } from 'lucide-react';
import { useState } from 'react';
import { useParams } from 'react-router';
import { useI18n } from '@/i18n/context';
import { usePublicProvider } from '../provider/api';
import { BackLink } from '../shared/back-link';
import { PublicProviderProfileView } from '../shared/public-provider-profile';
import { QueryView } from '../shared/query-view';
import { ReportButton, ReportPanel } from '../shared/report-button';

/** A provider's public profile for clients (P2-11), under My jobs: proposals on a job link here from P4. */
export function ProviderProfilePage() {
  const { id } = useParams();
  const { t } = useI18n();
  const query = usePublicProvider(id);
  const [reporting, setReporting] = useState(false);

  return (
    <div className="mx-auto grid w-full max-w-3xl gap-4">
      <BackLink to="/client/jobs" label={t.nav.myJobs} />
      <PageHeader
        title={t.publicProfile.title}
        actions={id && query.data && !reporting && <ReportButton onClick={() => setReporting(true)} />}
      />
      {id && reporting && <ReportPanel target="provider" targetId={id} onClose={() => setReporting(false)} />}
      <QueryView query={query} loading="detail">
        {(profile) =>
          profile ? (
            <PublicProviderProfileView profile={profile} />
          ) : (
            <EmptyState icon={SearchX} title={t.common.notFoundTitle} description={t.common.notFoundText} />
          )
        }
      </QueryView>
    </div>
  );
}
